export const ITEM_TYPE = {
  EXPENSE: 'expense',
  INCOME: 'income'
}
